import React from 'react';
import { useStyleConfig, vui } from '../core';
import Link from '../link';
import P from '../p';
import { cs } from '../utils';
import { useHeaderContext } from './context';
/** Displays a message with link to Marketplace if user has no services available. */
export const HeaderServicesMessage = vui((props, ref) => {
    const { children, className, ...rest } = props;
    const { links } = useHeaderContext() ?? {};
    const styles = useStyleConfig('Header', useHeaderContext());
    return (React.createElement(P, { className: cs('vui-headerServicesMessage', className), mb: 2, ml: 2, ref: ref, ...styles.servicesMessage, ...rest }, children ?? (React.createElement(React.Fragment, null,
        "No services available. ",
        React.createElement("br", null),
        "Explore more on the",
        ' ',
        React.createElement(Link, { href: links?.marketplace, isUnderlined: true }, "marketplace"),
        "."))));
});
export default HeaderServicesMessage;
